/**
 * Remove only the first starting bullet points from a given text
 * @param text
 * @returns
 */
export function removeStartingBulletPoints(text: string) {
	return text.replace(/^(\*( )+)+/, '');
}
